/**
 * The public inbox for the project.
 *
 * One address serves feedback, support, and legal/privacy requests, so it lives
 * here rather than next to any single page that links to it.
 */
export const CONTACT_EMAIL = "contact@fab-judge.fyi";

/** `mailto:` href for `CONTACT_EMAIL`, with an optional prefilled subject. */
export function contactHref(subject?: string): string {
  const base = `mailto:${CONTACT_EMAIL}`;
  return subject ? `${base}?subject=${encodeURIComponent(subject)}` : base;
}
